import { routesTemplate } from "../routesTemplate";

import PerformanceJourneys from "../../screens/journeyPerformance/PerformanceJourneys";
import PerformanceDetailsJourney from "../../screens/journeyPerformance/PerformanceDetailsJourney";

export const journeyPerformanceStack = [
    routesTemplate('/performance', PerformanceJourneys, "Performance"),
    routesTemplate('/performance/details', PerformanceDetailsJourney,),
];
